import React from 'react';
import { Card, CardProps } from 'antd';

import './AccountCard.less';

export type AccountCardProps = {
  className?: string
}

export type IAccountCardProps = AccountCardProps & CardProps

export function AccountCard(props: IAccountCardProps) {
  return (
    <Card
      {...props}
      className={`account-card ${props.className}`}
    >
      {props.children}
    </Card>
  );
}
